import axios from 'axios'
import { getHost } from './host'
import { ResponseNode, MonitorFirmware } from '../store/positions/types'

export async function getNodes(api_key: string, account_id: any) {
  
  const url = `https://${getHost()}/api/stations`
  
  const params = {  
    account_id: account_id,
    'expand':  ['monitor', 'boot_log', 'site', 'project', 'status']
  }

  const { data } = await axios.get<Array<ResponseNode>>(
    url,
    { 
      headers: {'X-API-KEY': api_key, Accept: 'application/json'},
      params: params
    });

  return data
}

export async function getLatestFirmware(api_key: string, monitor_id: number|string) {
  const url = `https://${getHost()}/api/monitor/check_firmware/`+monitor_id
  
  const { data } = await axios.get<{ data: Array<MonitorFirmware> }>(url, { headers: {'X-API-KEY': api_key, Accept: 'application/json'} });
  return data.data

}


